module.exports = __webpack_public_path__ + "static/media/pixel.0a525cfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pixel.png
// module id = 280
// module chunks = 1